import { getDomains } from '@/domains/core/platform/domains/getDomains';
import { getCurrentBaseUrl } from '@/domains/core/platform/getCurrentBaseUrl';
import { routes } from '@/domains/core/routing/routes/routes.default';
import { isB2C } from '@/domains/core/settings/utils';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { isValidRedirectUrl } from '@/domains/customerManagement/auth/services/server/validRedirectUrl';

export const useGetProRegisterRoute = (redirectUrl?: string) => {
  const { isAuthenticated, isGuest } = useAuth();
  const { domainPro, domainWww } = getDomains();

  const isValidRedirect = isValidRedirectUrl(redirectUrl);
  const isB2cAuthenticated = isB2C() && isAuthenticated;

  let route = `${getCurrentBaseUrl(domainPro)}${routes.register}`;

  if (isB2cAuthenticated || isGuest) {
    route = `${getCurrentBaseUrl(domainWww)}${isGuest ? routes.convertGuest : routes.conversionFromB2c2B2b}`;
  }

  return `${route}${redirectUrl && isValidRedirect ? `?redirect_url=${redirectUrl}` : ''}`;
};
